import React, { Component } from 'react';
import logo from './logo.svg';
import ProductCatalog from "./components/ProductCatalog";
import './App.css';

var products = ['one', 'second'];
class App extends Component {
  render() {
    return (
      <div className="App">
          <ProductCatalog products={products}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js